import React, { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { throttle } from "lodash";
import { object, shape } from "prop-types";
import get from "lodash/get";

import AuthorIntroductionCard from "../../../arrow/components/Rows/AuthorIntroductionCard";
import ThreeColGrid from "../../../arrow/components/Rows/ThreeColGrid";
import { getLoadMoreStories } from "../../utils";
import { useDeviceType } from "../../customHooks/useDeviceType";
import { STORY_HEADER_IN_VIEW } from "../../store/actions";
import { NO_STORIES_AUTHOR_PAGE } from "../../../constants";

import "./author.m.css";

export const AuthorPage = (props) => {
  const dispatch = useDispatch();
  const allStates = useSelector((state) => state);
  const authorHeader = useRef(null);
  const isMobile = useDeviceType() !== "desktop";
  const storyHeaderInView = get(allStates, "storyHeaderInView", true);
  const authorCollection = get(props, ["data", "authorCollection"], {});
  const initialLoadCount = authorCollection?.items?.length || 10;
  const [storiesToRender, setStoriesToRender] = useState(initialLoadCount);
  const [authorPageStories, setStories] = useState(authorCollection.items);
  const isAdfreePage = get(allStates, ["qt", "config", "subscriber"]) === "true";

  const handleScroll = () => {
    const authorHeaderPosition = authorHeader.current.getBoundingClientRect();
    if (authorHeaderPosition.bottom < 75 && storyHeaderInView && !isMobile) {
      dispatch({
        type: STORY_HEADER_IN_VIEW,
        payload: false,
      });
    } else if (authorHeaderPosition.bottom > 75 && !storyHeaderInView && !isMobile) {
      dispatch({
        type: STORY_HEADER_IN_VIEW,
        payload: true,
      });
    }
  };

  const throttledHandleScroll = throttle(handleScroll, 200);
  useEffect(() => {
    window.addEventListener("scroll", throttledHandleScroll);
    return () => {
      window.removeEventListener("scroll", throttledHandleScroll);
      throttledHandleScroll.cancel();
    };
  }, [throttledHandleScroll]);

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "dl_page_info",
      cms_author_name: "NA",
      byline: "NA",
      category: "author",
      sub_category: props?.data?.author?.name || "NA",
      content_id: props?.data?.author?.id || "NA",
      template_name: "authordetail",
      publish_date: "NA",
      publish_time: "NA",
      login_status: "not-logged-in", // will be changed
      subscription_status: "not-subscribed", // will be changed
      ad_free: false, // will be changed
      login_wall_enabled: false,
      platform: window.innerWidth >= 768 ? "Desktop" : "Mobile",
    });
  }, []);

  const authorCollectionStories = {
    items: authorPageStories.slice(0, storiesToRender),
  };

  const authorIntrCardConfig = {
    enableBio: true,
    enableSocialLinks: true,
  };

  const getMoreStories = async (offset, limit) => {
    await getLoadMoreStories({
      offset: offset,
      limit: isAdfreePage ? 6 : 5,
      authorId: props?.data?.author?.id,
      slug: props?.data?.query,
      setStories: setStories,
      storiesToRender: storiesToRender,
      setStoriesToRender: setStoriesToRender,
      stories: authorPageStories,
    });
  };

  return (
    <div className="container" styleName="wrapper">
      <span ref={authorHeader}>
        <AuthorIntroductionCard data={props?.data?.author} config={authorIntrCardConfig} template="square" />
      </span>
      <div styleName={`${isAdfreePage ? "ad-free-content-container" : "content-container"}`}>
        <h2 styleName="stories-byline" className="stories-byline">
          Stories by {props?.data?.author?.name}
        </h2>
        {authorCollectionStories?.items?.length > 0 ? (
          <ThreeColGrid
            collection={authorCollectionStories}
            config={{ buttonText: "Load More", footerButton: "SubsequentLoadCount", showAuthor: true, showTime: true }}
            isLoadMoreVisible={authorCollection["total-count"] > authorPageStories.length}
            getMoreStories={getMoreStories}
            initialLoadCount={11}
            isolatedLoadMore={true}
            page="author-page"
            adType="grid_ad"
            showAuthorContent={false}
          />
        ) : (
          <h1 styleName="text-info">{NO_STORIES_AUTHOR_PAGE}</h1>
        )}
      </div>
    </div>
  );
};

AuthorPage.propTypes = {
  data: shape({
    author: object,
    authorCollection: object,
  }),
};
